/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-07 10:41:08
 * @LastEditors: Gao Deng gaodeng@nextmar.com
 * @LastEditTime: 2025-05-07 21:24:01
 * @FilePath: /zeelool-nextjs/src/components/MobileNav/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'use client';
import { EPlatform } from '@/utils/enums/platform-enum';
import { WapNavBackOutlined } from '@zeelool/icon';
import { useRouter } from 'next/navigation';
import React, { useContext } from 'react';
import { ResponsiveContext } from '../Responsive/ResponsiveProvider';
export default function MobileNav({
  title = '',
  goBackPath,
  className,
  leftSlot = null,
  rightSlot = null,
  titleClassName = '',
  leftSlotClassName = '',
  goBack,
  style = {},
}: {
  title?: string;
  goBackPath?: string;
  goBack?: () => void;
  className?: string;
  leftSlot?: React.ReactNode;
  rightSlot?: React.ReactNode;
  titleClassName?: React.ReactNode;
  leftSlotClassName?: string;
  style?: React.CSSProperties;
}) {
  const router = useRouter();
  const { deviceType } = useContext(ResponsiveContext);
  const inAppH5 = [EPlatform.ANDROID, EPlatform.IOS].includes(deviceType);
  const handleGoBack = () => {
    if (goBack) {
      goBack();
      return;
    }
    // 搜了全局，有配置goBackPath的都是个人中心的内部链接
    // 所以这里就直接用router.push来跳转
    if (goBackPath) {
      router.push(goBackPath);
      return;
    }
    // 存在浏览记录时跳转回上一页，无记录时跳转到首页
    if (window.history.length > 1) {
      router.back();
    } else {
      router.push('/');
    }
  };
  return (
    <div
      className={`relative px-[4vw] flex items-center h-[50px] justify-between ${className || ''}`}
      style={{ ...style }}
    >
      {!inAppH5
        ? leftSlot || (
            <div
              className="MobileNav flex items-center justify-center h-[40px] w-[40px] absolute left-0 top-5"
              onClick={handleGoBack}
            >
              <WapNavBackOutlined className={`text-20 text-[#333333] ${leftSlotClassName}`} />
            </div>
          )
        : null}
      <h2 className={`text-16 font-bs w-full text-center ${titleClassName}`}>{title}</h2>
      {rightSlot}
    </div>
  );
}
